import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StrategyService } from 'app/strategies/services/strategy.service';
import { OfferService } from 'app/offers/services/offer.service';
import { finalize } from 'rxjs/operators';
import { addDays } from 'app/shared/utils/dates';

@Component({
  selector: 'app-dialog-reward-move',
  templateUrl: './dialog-reward-move.component.html',
  styleUrls: ['./dialog-reward-move.component.sass']
})
export class DialogRewardMoveComponent implements OnInit {
  offer: any = {};
  strategy: any = {};
  defaultPhase: any = {};
  phases: any = [];
  loading = false;
  isActive = false;
  isEnded = false;
  model = {
    id: null,
    strategy_phase_id: null,
    start_date: addDays(new Date(), 1),
    end_date: null,
    cashback_rate: 0,
    legal_terms: '',
    translation: {}
  };
  selectedPhase: any = null;

  constructor(
    private offerService: OfferService,
    private strategyService: StrategyService,
    public dialogRef: MatDialogRef<DialogRewardMoveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.offer = data.offer;
    this.strategy = data.strategy;
    this.defaultPhase = data.defaultPhase;

    if (data.phase) {
      for (const key in this.model) {
        if (key === 'start_date' && !this.setIsActive(this.model[key])) {
          // Don't modify input
        } else {
          this.model[key] = data.phase[key]
        }
      }
    }

    if (!this.model.strategy_phase_id) {
      this.loadPhases();
    } else {
      this.selectedPhase = data.phase.strategy;

      this.isEnded = this.setIsEnded(data.phase) || this.isCompleted();
      this.isActive = this.setIsActive(data.phase);
    }
  }

  ngOnInit() {
  }

  loadPhases() {
    this.loading = true;

    this.strategyService.fetchPhases(this.offer.strategy_id)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response: any) => {
        this.phases = response.items;

        if (this.phases.length === 1) {
          this.onSelectPhase(this.phases[0])
        }
      });
  }

  onSelectPhase(phase: any) {
    this.selectedPhase = phase;

    let realStartDate = new Date()

    if (realStartDate < new Date(phase.start_date)) {
      realStartDate = phase.start_date
    }

    this.model.strategy_phase_id = phase.id;
    this.model.cashback_rate = phase.playground.default
    this.model.start_date = realStartDate
    this.model.end_date = phase.end_date
  }

  computeDefaultLeftPercent() {
    const percent = this.selectedPhase.playground.default / this.selectedPhase.playground.max * 100;

    return percent;
  }

  getStartDateMin() {
    const availableDate = addDays(new Date(), 1)

    if (!this.selectedPhase.start_date) {
      return availableDate;
    }

    if (new Date(availableDate) < new Date(this.selectedPhase.start_date)) {
      return this.selectedPhase.start_date;
    }

    return availableDate;
  }

  isCompleted() {
    return ['ENDED', 'COMPLETED', 'DEACTIVATED'].includes(this.offer.status)
  }

  isFieldDisabled(field) {
    if (this.isEnded) {
      return true
    }

    if (this.isActive && !this.isEnded) {
      if (!['end_date', 'start_date', 'cashback_rate', 'terms'].includes(field)) {
        return true
      }
    }
  }

  setIsEnded(phase) {
    if (!phase.end_date) {
      return false
    }
    const endDate = new Date(phase.end_date).setUTCHours(0, 0, 0, 0);
    const today = new Date().setUTCHours(0, 0, 0, 0);

    return endDate < today;
  }

  setIsActive(phase) {
    const startDate = new Date(phase.start_date).setUTCHours(0, 0, 0, 0);
    const today = new Date().setUTCHours(0, 0, 0, 0);

    return startDate <= today;
  }

  getStartDateMax() {
      return this.model.end_date
  }

  getEndDateMin() {
    if (this.isActive) {
      return new Date()
    }
    return this.model.start_date
  }

  getEndDateMax() {
    if (!this.selectedPhase.end_date || new Date(this.offer.end_date) < new Date(this.selectedPhase.end_date)) {
      return this.offer.end_date
    }

    return this.selectedPhase.end_date
  }

  onSubmit(form) {
    if (!form.form.invalid) {
      this.offerService.savePhase(this.offer.id, this.model).subscribe((response) => {
        this.dialogRef.close(true);
      })
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
